import type { Venue } from "./merchant.types";

export function isVenueLive(venue: Pick<Venue, "is_alive">): boolean {
  return venue.is_alive !== false;
}

export function liveVenues<T extends Pick<Venue, "is_alive">>(
  venues: T[],
): T[] {
  return venues.filter(isVenueLive);
}
